<div class="padding flex column">
  <b>Select language</b>

  <div class="flex center gap margin-top">
    <button class="flex-1" (click)="selectLanguage('en')">
      <i class="fa-solid fa-download margin-right-small"></i>
      English
    </button>
    <button class="flex-1" (click)="selectLanguage('it')">
      <i class="fa-solid fa-download margin-right-small"></i>
      Italiano
    </button>
  </div>
</div>
